// API Configuration for ANN Governance Frontend
// This file reads from environment variables set at build time

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const API_CONFIG = {
    BASE_URL: API_BASE_URL,
    ENDPOINTS: {
        MODULES: `${API_BASE_URL}/api/v1/modules`,
        BACKEND_CONFIG: `${API_BASE_URL}/api/v1/config/backend`,
        ZONES: `${API_BASE_URL}/api/v1/zones`,
        MODEL_DETAILS: (moduleId) => `${API_BASE_URL}/api/v1/model-details/${moduleId}`,
        PREDICT: (moduleId) => `${API_BASE_URL}/api/v1/predict/${moduleId}`,
        RETRAIN: (moduleId) => `${API_BASE_URL}/api/v1/retrain/${moduleId}`,
        SWITCH_BACKEND: `${API_BASE_URL}/api/v1/config/backend`,
        PROJECT_INFO: `${API_BASE_URL}/api/v1/project-info`,
        METADATA: `${API_BASE_URL}/api/v1/metadata`,
        HEALTH: `${API_BASE_URL}/api/v1/health`,
    }
};

export default API_CONFIG;
